import localforage from 'localforage'
import {asyncDebounce} from '../common/asyncDebounce';

function rejectWithMessage(error?: any) {
    return Promise.reject(error?.message ?? error);
}

const reducer = (key: string, replacer?: (this: any, key: string, value: any) => any, reviver?: (this: any, key: string, value: any) => any) => {
    
    // Sometimes is spawns too many reuests which with big redux model causes out of memory error

    return {
        load() {
            return localforage.getItem(key).then((jsonState: unknown) => {
                if (!!jsonState && typeof jsonState === 'string') {
                    return JSON.parse(jsonState, reviver) ?? {}
                }
                return {}
            }).catch(rejectWithMessage)
        },

        //save: asyncDebounce( (state: any) => { return localforage.setItem(key, JSON.stringify(state, replacer)).then(() => "").catch(rejectWithMessage) }, 500)
        save:  (state: any) => { return localforage.setItem(key, JSON.stringify(state, replacer)).then(() => "").catch(rejectWithMessage) }
    };
}

export default reducer;
